import {atom, atomFamily} from 'recoil';
import {GroupMapping} from "../model/Group.ts";
import {UserAccountInfo} from "../model/UserAccountInfo.ts";
import {SelectOptionType} from "../model/SelectOptionType.ts";

export const usersTotalNumberAtom = atom({
    key: "usersTotalNumberAtom",
    default: 0
})

export const searchUsersAtom = atom({
    key: 'searchUsersAtom',
    default: ''
})

export const userFilterAllAtom = atom({
    key: `userFilterAllAtom`,
    default: false
})

export const userFilterLastLoginPeriodAtom = atom<SelectOptionType<number>>({
    key: `userFilterLastLoginPeriodAtom`,
    default: { value: -1, label: '0 month' }
})

export const userFilterIssuerAtom = atom<SelectOptionType<string>>({
    key: `userFilterIssuerAtom`,
    default: { value: "", label: 'All' },
})

export const userSearchGroupAtomFamily = atomFamily({
    key: `userSearchGroupAllAtomFamily`,
    default: ''
})

export const userSearchGroupAssignedAtomFamily = atomFamily({
    key: `userSearchGroupAssignedAtomFamily`,
    default: ''
})

export const userDetailGroupExpandedFamily = atomFamily<boolean, number>({
    key: `userDetailGroupExpandedFamily`,
    default: false
})

export const currentUserManagerGroupAtomFamily = atomFamily<GroupMapping[] | null, number>({
    key: 'currentUserManagerGroupAtomFamily',
    default: []
})
export const selectedUserIdsAtom = atom<number[]>({
    key: 'selectedUserIdsAtom',
    default: []
})

export const userAccountInfoAtom = atom<UserAccountInfo>({
    key: 'userAccountInfoAtom',
    default: {account: null, isAuthenticated: false, manager_of_group_ids: [], roles: [], user: null}
})